<script>
export default {
  methods: {
    formatedEntityLabel: function ({ name, cities, entitiesIds, entitiesWithPermissions }) {
      // Its showing a cluster so add the number of entities of that cluster to the label
      if (Array.isArray(entitiesIds)) {
        if (!entitiesWithPermissions) {
          return name
        }
        return `${name} ${this.$t('users.roles.custom_clusters_label', { number: entitiesWithPermissions })}`
      }

      let nameWithCities = name

      if (Array.isArray(cities) && cities.length > 0) {
        nameWithCities = `${nameWithCities} (${cities.join(', ')})`
      }

      return nameWithCities
    },
    formatedUserLabel: function ({ name, nickname, entity }) {
      let label = name
      if (nickname) {
        label += ` (${nickname}) `
      }
      if (entity && entity.hasOwnProperty('name')) {
        label += ` (${entity.name})`
      }
      return label
    },
    limitText: function (count) {
      return this.$t('tables.multiselect_limitText_and') + count + this.$t('tables.multiselect_limitText_others')
    },
  }
}
</script>
